import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};
export default function EstateWrapper({ children }: Props) {
  return (
    <div
      id="tablet"
      className="relative flex gap-5 size-full p-7.5 bg-dark-900 rounded-4 overflow-clip"
    >
      {children}
    </div>
  );
}
